export default {
	app_name: 'WelaCoffee',
	btn: {
		yes: 'ใช่',
		no: 'ไม่ใช่',
		cancel: 'ยกเลิก',
		discard_changes: 'ยกเลิกการเปลี่ยนแปลง',
		save: 'บันทึก',
		close: 'ปิด',
		clear: 'ล้าง',
		applyFilters: 'บันทึกตัวกรอง',
		search: 'ค้นหา',
		delete: 'ลบ',
		signout: 'ออกจากระบบ',
		next: 'ถัดไป',
		previous: 'ก่อนหน้า',
		add: 'เพิ่ม',
		submit: 'Submit'
	},
	dialog: {
		title: 'ข้อความ',
		discard_changes_message: 'Discard any changes?',
		delete_data_message: 'Are you sure to delete this data?',
		remove_component_message: 'Are you sure to remove this component?'
	},
	overview: {
		title: 'Payment',
		no_data: {
			header: 'ไม่พบรายการสั่งซื้อของคุณ !?',
			sub_header: 'อาจเกิดจากความผิดพลาดระหว่างการสั่งซื้อ กรุณาตรวจสอบหรือติดต่อผู้ดูแลระบบอีกครั้ง'
		},
		stepper: {
			step1: {
				default: 'ยืนยันคำสั่งซื้อ',
				order: {
					header: 'คำสั่งซื้อ #%{orderNo}',
					sub_header: 'จำนวนสินค้าภายในคำสั่งซื้อนี้ %{count} ชิ้น',
					shipping_price: 'ค่าส่งสินค้า',
					total_price: 'ราคาสินค้า',
					net_price: 'ยอดที่ต้องชำระ',
				},
				payment: {
					header: 'ช่องทางการชำระสินค้า',
					sub_header: 'กรุณาเลือกวิธีการที่สะดวกที่สุดสำหรับคุณ ในการชำระเงิน',
					btn_action: 'เริ่มการชำระเงิน',
				},
			},
			step2: {
				default: 'กรอกรายละเอียดการชำระเงิน',
				no_data: 'ไม่มีการกำหนดรูปแบบการชำระเงิน',
				credit: {
					header: 'ชำระเงินผ่านบัตรเครดิต/เดบิต',
					sub_header: 'กรอกรายละเอียดด้านล่างเพื่อดำเนินการชำระเงิน',
					card_holder: 'ชื่อผู้ถือบัตร',
					card_no: 'หมายเลขบัตร (ด้านหน้าบัตร)',
					card_no_placeholder: 'รหัสเลข 16 หลัก',
					expire: 'เดือน/ปีที่บัตรหมดอายุ',
					expire_placeholder: 'MM/YY',
					cvv: 'รหัส CVV (ด้านหลังบัตร)',
					cvv_placeholder: 'รหัสเลข 3 หลัก',
					btn_action: 'ชำระด้วยบัตรเครดิต/เดบิต',
					btn_back: 'เลือกวิธีการชำระเงินใหม่',
					confirm_message: 'ข้อมูลบัตรเครดิตถูกต้องใช่หรือไม่?',
					save_fail: 'ข้อมูลบัตรเครดิตของคุณไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง',
					validator: {
						card_holder: '^กรุณากรอกชื่อผู้ถือบัตร',
						card_no: '^กรุณากรอกหมายเลขบัตร',
						expire: '^กรุณากรอกเดือน/ปีที่บัตรหมดอายุ',
						cvv: '^กรุณากรอกรหัส CVV',
					},
				},
				transfer: {
					header: 'ชำระผ่านการโอนเงิน',
					sub_header: 'ชำระเงินด้วยวิธีการโอนเงินผ่านทางบัญชีธนาคาร และแจ้งรายละเอียดให้ผู้ดูแลระบบตรวจสอบ',
					btn_copy: 'คัดลอกบัญชี',
					btn_copied: 'คัดลอกแล้ว',
					account_name: 'ชื่อบัญชี',
					bank_code: 'ธนาคาร',
					transaction_date: 'วันที่โอนเงิน',
					transaction_time: 'เวลาที่โอนงิน',
					attach: 'แนบสลิปการโอนเงิน',
					attach_hint: 'คลิกหรือลากไฟล์มาตรงนี้',
					attach_info: 'ภาพแสดงรายละเอียดการโอนเงินชัดเจน',
					btn_action: 'แจ้งรายละเอียดการชำระเงิน',
					btn_back: 'เลือกวิธีการชำระเงินใหม่',
					validator: {
						account_name: '^กรุณากรอกชื่อบัญชี',
						bank_code: '^กรุณาเลือกธนาตาร',
					},
				},
				qrcode: {
					header: 'ชำระผ่านการสแกน QR Code',
					sub_header: 'เปิดแอพพลิเคชันธนาคารของคุณเพื่อใช้งานการสแกน',
					transaction_date: 'วันที่สแกนจ่าย',
					transaction_time: 'เวลาที่สแกนจ่าย',
					attach: 'แนบสลิปการสแกนจ่าย',
					attach_hint: 'คลิกหรือลากไฟล์มาตรงนี้',
					attach_info: 'ภาพแสดงรายละเอียดการโอนเงินชัดเจน',
					btn_action: 'แจ้งรายละเอียดการสแกนจ่าย',
					btn_back: 'เลือกวิธีการชำระเงินใหม่',
				},
				linepay: {
					header: 'ชำระผ่าน Line Pay',
					sub_header: 'คลิกปุ่มด้านล่างเพื่อเริ่มการชำระเงินด้วย Line Pay',
					btn_action: 'เปิดแอพพลิเคชัน Line Pay',
					btn_back: 'เลือกวิธีการชำระเงินใหม่',
				},
			},
			step3: {
				default: 'ดำเนินการชำระเงิน',
				header: 'ขอบคุณสำหรับการชำระเงิน !!',
				sub_header: 'ทางทีมผู้ดูแลระบบจะติดต่อกลับอีกครั้ง หลังจากตรวจสอบข้อมูลการชำระเรียบร้อยแล้ว',
			}
		},
	},
};
